import * as React from 'react';
import { useTranslation } from '@herob191/gatsby-plugin-react-i18next';
import { FooterMenu } from './MenuItems';
import logo from '../img/gecko-logo-white.svg';
import gijn from '/static/img/gijn-logo-white.png';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="mt-0 grid grid-cols-12 bg-black px-12 py-12 font-sans text-white">
      <div className="col-span-full md:col-span-6">
        <img src={logo} alt="The Gecko Project" className="h-24" />
        <div className="pt-8 text-sm font-light">
          <p>{t('common:footer.orgDetails')}</p>
          <p>{t('common:footer.orgNumber')}</p>
          <p>{t('common:footer.orgAddress')}</p>
        </div>
        <div className="mt-4 inline-block text-sm">
          <p className="mb-2">{t('common:footer.memberOf')}</p>
          <a
            href="https://gijn.org/"
            className="inline-block border-t-2 border-t-gecko-red"
          >
            <img src={gijn} alt="GIJN Logo" className="h-12 pt-2" />
          </a>
        </div>
      </div>
      <FooterMenu />
    </footer>
  );
};
export default Footer;
